import { render, staticRenderFns } from "./PackingReport.vue?vue&type=template&id=64b70c4c"
import script from "./PackingReport.vue?vue&type=script&lang=js"
export * from "./PackingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports